const Feedback = () => import('@app/Forms/Feedback')
const FeedbackSmall = () => import('@app/Forms/FeedbackSmall')
const FeedbackLarge = () => import('@app/Forms/FeedbackLarge')
const AddNewSeller = () => import('@app/Forms/AddNewSeller')
const FormGenerator = () => import('@app/Forms/FormGenerator')
const ModalShopInformationBack = () => import('@app/Forms/ModalShopInformationBack')
const ModalShopInformationGuarantee = () => import('@app/Forms/ModalShopInformationGuarantee')

export default function install(Vue) {
  Vue.component('Feedback', Feedback)
  Vue.component('FeedbackLarge', FeedbackLarge)
  Vue.component('FeedbackSmall', FeedbackSmall)
  Vue.component('AddNewSeller', AddNewSeller)
  Vue.component('FormGenerator', FormGenerator)
  Vue.component('ModalShopInformationBack', ModalShopInformationBack)
  Vue.component('ModalShopInformationGuarantee', ModalShopInformationGuarantee)
}
